import { DisplayAd as DisplayAdsSlot } from '@tunein/display-ads/react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { mintSingleton } from 'src/client/mint';
import { DISPLAY_ADS_LIBRARY_ENABLED } from 'src/common/constants/experiments/ads';
import useExperiment from 'src/common/hooks/useExperiment';
import { getDisplayAdPlacement } from 'src/common/utils/ads/config';
import { logCategoryActionLabel } from '../../actions/logging';
import webCategory from '../../constants/analytics/categoryActionLabel/web';
import useActions from '../../hooks/useActions';
import { selectIsDiscord, selectUserAgent } from '../../selectors/app';
import { selectDeregisterDisplayAds } from '../../selectors/mint';
import DisplayAdSlot from './DisplayAdSlot';

const styles = {
  adContainer: {
    margin: '0',
    textAlign: 'center',
    pointerEvents: 'auto',
  },
  link: {
    display: 'block',
    cursor: 'default',
    lineHeight: 0,
    opacity: 0,
  },
};

export default function DisplayAd(props) {
  const { placement, slotName, style, className, isInDialog } = props;
  const deregisterDisplayAds = useSelector(selectDeregisterDisplayAds);
  const isDiscord = useSelector(selectIsDiscord);
  const userAgent = useSelector(selectUserAgent);
  const actions = useActions({ logCategoryActionLabel });
  const isDisplayAdsLibraryEnabled = useExperiment(DISPLAY_ADS_LIBRARY_ENABLED, false);
  const resolvedPlacement = placement || getDisplayAdPlacement(slotName);

  console.log('[DEBUG] isDisplayAdsLibraryEnabled', isDisplayAdsLibraryEnabled);

  const disableAdsAndLog = () => {
    mintSingleton.instance?.disableAds();
    actions.logCategoryActionLabel({
      category: webCategory.category,
      action: webCategory.actions.honeypot,
      label: userAgent,
    });
  };

  if (!isDisplayAdsLibraryEnabled) {
    return isDiscord ? null : (
      <DisplayAdSlot
        {...props}
        deregisterDisplayAds={deregisterDisplayAds}
        deregisterDisplaySlot={deregisterDisplayAds}
      />
    );
  }

  return isDiscord || (!isInDialog && deregisterDisplayAds) || !resolvedPlacement ? null : (
    <div className={className} style={{ ...styles.adContainer, ...style }}>
      <DisplayAdsSlot placement={resolvedPlacement} />
      {/* This is a honeypot to catch click bots. */}
      <a
        id="ad_unit"
        data-testid="adUnit"
        onClick={disableAdsAndLog}
        style={{ ...styles.link }}
        aria-hidden="true"
      >
        --
      </a>
    </div>
  );
}

DisplayAd.propTypes = {
  placement: PropTypes.string,
  slotName: PropTypes.string,
  style: PropTypes.object,
  className: PropTypes.string,
  isInDialog: PropTypes.bool,
};
